export const DetailsTableconstant ={

    DETAILS_TABLE_SAGA: "DETAILS_TABLE_SAGA",
    DETAILS_TABLE_REQUEST: "DETAILS_TABLE_REQUEST",
    DETAILS_TABLE_RESPONSE: "DETAILS_TABLE_RESPONSE",
    DETAILS_TABLE_API: "/manufacturer-details", 

}